/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import FeedPostCommentReply from './FeedPostCommentReply';

const FeedPostCommentRepliesContainer = styled('div')`
  border-left: 1px solid #f0f0f0;
  margin-left: -30px;
  margin-bottom: 10px;
  padding-left: 80px;
  margin-top: 10px;
`;

const FeedPostCommentReplies = ({
  replies,
  feedPost,
  comment,
}) => {
  const currentUser = useSelector((state) => state.auth.data.currentUser);

  const feedPostCommentReplyMapper = () => replies
    .map((reply) => (
      <FeedPostCommentReply
        id={reply.id}
        key={reply.id}
        reply={reply}
        currentUser={currentUser}
        feedPost={feedPost}
        comment={comment}
      />
    ));

  return (
    <FeedPostCommentRepliesContainer>
      {feedPostCommentReplyMapper()}
    </FeedPostCommentRepliesContainer>
  );
};

FeedPostCommentReplies.propTypes = {
  replies: PropTypes.instanceOf(Object).isRequired,
  feedPost: PropTypes.instanceOf(Object).isRequired,
  comment: PropTypes.instanceOf(Object).isRequired,
};

export default FeedPostCommentReplies;
